import React from 'react'
import createClass from 'create-react-class'
import { ObjectInitializerMixin } from '../constant'
import i18n from 'live/services/i18n'
import { MainForm } from '../Components/MainForm'

const FormBase = require('live/components/extensions/ui/form')
const FormGroup = require('live/components/forms/ui/form-group')

export default createClass({
    mixins: [
        require('live/components/forms/mixins/object-initializer')('/rest/extension', ObjectInitializerMixin),
        require('live/components/forms/mixins/validation-mixin')
    ],
    validations: {},
    getInitialState: function () {
        return {
            providerOptions: []
        }
    },
    _onSuccess: function () {
        window.location.href = '#/integrations/' + this.state.object.type + '/' + this.state.object.id
    },
    _onDelete: function () {
        window.location.href = '#/integrations/'
    },
    onChangeStr: function (field, value) {
        this.setState({
            ...this.state,
            object: {
                ...this.state.object,
                config: {
                    ...this.state.object.config,
                    [field]: String(value)
                }
            }
        })
    },
    onChangeBool: function (field) {
        this.setState({
            ...this.state,
            object: {
                ...this.state.object,
                config: {
                    ...this.state.object.config,
                    [field]: !this?.state?.object.config[field]
                }
            }
        })
    },
    onChangeObjConfig: function (obj) {
        this.setState({
            ...this.state,
            object: {
                ...this.state.object,
                config: {
                    ...this.state.object.config,
                    ...obj
                }
            }
        })
    },
    render: function () {
        const object = this.state.object
        const config = object.config
        
        return (
            <FormBase self={this}>
                <div className="form-area">
                    <FormGroup
                        type="text"
                        label={i18n('Span')}
                        name="span"
                        value={config?.span}
                        autoComplete="off"
                        onChange={({ target }) => this.onChangeStr('span', target?.value)}
                        validationState={this.validationState('config.span')}
                        hasFeedback
                        help={this.errorsFor('config.span')}
                    />
                </div>
                <div className="form-area">                    
                    <FormGroup
                        type="checkbox"
                        label={i18n('Real time')}
                        name="isRealtime"
                        checked={config?.isRealtime}
                        autoComplete="off"
                        onChange={() => this.onChangeBool('isRealtime')}
                        validationState={this.validationState('config.isRealtime')}
                        hasFeedback
                        help={this.errorsFor('config.isRealtime')}
                    />
                </div>
                <MainForm
                    onChangeStr={this.onChangeStr.bind(this)}
                    onChangeObjConfig={this.onChangeObjConfig.bind(this)}
                    expression={config?.expression}
                    span={config?.span}
                    follow={config?.isRealtime}
                    provider={config?.queryProvider}
                />
            </FormBase>
        )
    }
})
